import { render, staticRenderFns } from "./GenericPermissions.vue?vue&type=template&id=69ca3198"
import script from "./GenericPermissions.vue?vue&type=script&lang=js"
export * from "./GenericPermissions.vue?vue&type=script&lang=js"
import style0 from "./GenericPermissions.vue?vue&type=style&index=0&id=69ca3198&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports